import { render } from "./CZGasDemand.vue?vue&type=template&id=f2888b90&ts=true"
import script from "./CZGasDemand.vue?vue&type=script&lang=ts"
export * from "./CZGasDemand.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Develop\\Czone_UI_EIC\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__